import DropdownVehiclesPlaceholder from './DropdownVehiclesPlaceholder';

export default DropdownVehiclesPlaceholder;
